/*
 * Copyright (c) 2023-2024 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import type { AccelbyteSDK, SDKOptions, SDKRequestConfig } from '@accelbyte/sdk'

// Dev's note: this is a "hacky" way at the moment to play around `@accelbyte/sdk`.
// By default, our `@accelbyte/sdk` package is tied to Justice ecosystem. That is, Player Portal, Admin Portal, Justice IAM, and all that.
//
// In our case, Customer Portal, we don't use all of those things, including the automatic `POST /iam/v3/oauth/token` when we got `401 Unauthenticated`.
// With that automatic request when we get `401 Unauthenticated`, our proxy server will "spam" that endpoint, keeps getting `404 Not Found` in the meantime.
//
// Hence, since the individual SDKs generated by `@accelbyte/codegen` requires only the `sdk.assembly()`, we kinda "mock" it so we can still
// get the functionality of the SDK without the default Justice interceptors.

export const createCustomerPortalSDK = (params: { options: SDKOptions; config?: SDKRequestConfig<any> }) =>
  ({
    refreshTokens: () => {
      // No-op
    },
    assembly: () => ({
      config: {
        ...params.config,
        baseURL: params.options.baseURL,
        headers: {
          ...params.config?.headers
        }
      },
      ...params.options
    })
  }) as AccelbyteSDK

export interface CustomerPortalSDK extends AccelbyteSDK {}
